import { ExportRequest } from '@stylehaven/components';

export interface ExportDialogOutputCancel {
    type: 'cancel';
}

export interface ExportDialogOutputSuccess {
    exportRequest: ExportRequest;
    exportDirect: boolean;
}

export type ExportDialogOutput = ExportDialogOutputCancel | ExportDialogOutputSuccess;

export enum ExportType {
    DOWNLOAD = 'download',
    EXPORT = 'export'
}

export interface ExportControlSettings {
    label?: string;
    default?: string | boolean;
    disabled: boolean;
    visible: boolean;
}

export const customReasonOptionValue = 'CUSTOM';
